import { Page } from '@/core/architecture'

import { MyOwnedTicketDetailTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * MyOwnedTicketDetail Page
 * Implemented as a practical sample.
 */
export const MyOwnedTicketDetail: Page = () => {
  const { state, actions } = useViewModel()

  return <MyOwnedTicketDetailTemplate state={state} {...actions} />
}
